<div class="d-flex flex-column basis-100">
  <div class="order-documents-frame mx-4">
    <div
      class="carrier-profile-container container-blue-open d-flex flex-column gap-32"
      id="carrier-profile"
    >
      <form #carrierForm="ngForm">
        <div
          class="d-flex flex-row justify-center gap-16 md-gap-0 sm-gap-0 xs-flex-column"
        >
          <ng-container *ngIf="!myProfile">
            <div
              class="carrier-container material-shadow info-container d-flex flex-column basis-48 xs-basis-100"
              [ngClass]="!myProfile ? 'not-my-profile' : ''"
            >
              <ng-container *ngIf="!myProfile; then generalInfo">
              </ng-container>
            </div>
          </ng-container>

          <div
            class="carrier-container material-shadow my-profile-info-container d-flex flex-column basis-49 xs-basis-100"
            [ngClass]="
              !myProfile ? 'not-profile-my-profile-info-container' : ''
            "
          >
            <ng-container *ngIf="myProfile; then generalInfo"> </ng-container>
            <div class="d-flex justify-between items-center">
              <h2 class="title-group">
                {{ 'CARRIER-APPROVE.LOCATION-DETAILS' | translate }}
              </h2>
              <button
                mat-raised-button
                color="primary"
                type="button"
                class="close mt-0"
                ngClass="mt-0"
                ngClass.xs="mt-3"
                id="general-info-edit-btn"
                *ngIf="editAvailable && !myProfile && !isMobile"
                title="{{ 'SHARED.SAVE' | translate }}"
                (click)="saveGeneralInformation(carrierForm)"
              >
                {{ 'SHARED.SAVE' | translate }}
              </button>
            </div>

            <div class="control-group" style="padding: 10px">
              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.CITY' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="8"
                      maxlength="50"
                      minLength="1"
                      name="city"
                      id="city"
                      [(ngModel)]="model.city"
                      #City="ngModel"
                      class="input input-cp-control"
                      type="text"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.ZIP-CODE' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="9"
                      maxlength="50"
                      minLength="1"
                      name="zipcode"
                      id="zipcode"
                      [(ngModel)]="model.zipCode"
                      #ZipCode="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.STREET-NR' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="10"
                      maxlength="100"
                      minLength="1"
                      name="street"
                      id="street"
                      [(ngModel)]="model.street"
                      #StreetAndNr="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.COUNTRY' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="11"
                      maxlength="50"
                      minLength="1"
                      name="country"
                      id="country"
                      [(ngModel)]="model.country"
                      #Country="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              [ngClass]="
                myProfile ? 'hide-tablet-landscape hide-tablet-portrait' : ''
              "
            >
              <h2 class="title-group">Contact</h2>
              <div class="control-group" style="padding: 10px">
                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.CONTACT-NAME' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="12"
                        maxlength="100"
                        minLength="1"
                        id="contact"
                        name="contact"
                        [(ngModel)]="model.contactPerson"
                        #ContactPerson="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.PHONE-NUMBER' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="13"
                        maxlength="50"
                        minLength="1"
                        id="phone"
                        name="phone"
                        [(ngModel)]="model.phoneNumber"
                        #PhoneNumber="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.MOBILE-PHONE-NUMBER' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="14"
                        maxlength="50"
                        minLength="1"
                        id="mobile"
                        name="mobile"
                        [(ngModel)]="model.mobilePhoneNumber"
                        #MobilePhoneNumber="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.FAX-NUMBER' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="15"
                        maxlength="50"
                        minLength="1"
                        id="fax"
                        name="fax"
                        [(ngModel)]="model.faxNumber"
                        #FaxNumber="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.EMAIL-ADDRESS' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="16"
                        maxlength="100"
                        minLength="1"
                        name="email"
                        id="email"
                        (input)="clearEmailError()"
                        (focusout)="validateEmail(Email.control)"
                        [(ngModel)]="model.email"
                        #Email="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        [pattern]="emailRegex"
                        type="email"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div class="control display-control">
                  <h3
                    class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                  >
                    {{ 'CARRIER-APPROVE.WEB-SITE' | translate }}
                  </h3>
                  <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                    <div class="col-12 col-xl-4">
                      <input
                        tabindex="17"
                        id="website"
                        pattern="^(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,4}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&amp;?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?$"
                        maxlength="50"
                        minLength="1"
                        name="website"
                        [(ngModel)]="model.website"
                        #Website="ngModel"
                        class="input input-cp-control"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                        type="url"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              [ngClass]="
                myProfile ? 'hide-tablet-landscape hide-tablet-portrait ' : ''
              "
              *ngIf="myProfile"
            >
              <h2 class="title-group">
                {{ 'CARRIER-APPROVE.EQUIPMENT' | translate }}
              </h2>
              <div class="control-group" style="padding: 10px">
                <div
                  class="control display-control md-flex-column sm-flex-column xs-flex-column"
                >
                  <h3 class="desktop-font-size mobile-elem label-text">
                    {{ 'CARRIER-APPROVE.EQUIPMENT-TYPE' | translate }}
                  </h3>
                  <div class="toggle-container basis-100">
                    <div class="d-flex flex-row">
                      <div class="basis-50 gap-16">
                        <mat-slide-toggle
                          [color]="color"
                          class="toggle"
                          [(ngModel)]="foodChecked"
                          name="foodCheck"
                        >
                        </mat-slide-toggle>

                        <span
                          class="desktop-font-size mobile-elem toggle-title basis-70 md-basis-80 sm-basis-80 xs-basis-80"
                        >
                          {{ 'CARRIER-APPROVE.FOOD' | translate }}
                        </span>
                      </div>
                      <div class="basis-50 gap-16">
                        <mat-slide-toggle
                          [color]="color"
                          class="toggle"
                          [(ngModel)]="technicalChecked"
                          name="technicalCheck"
                        >
                        </mat-slide-toggle>

                        <span
                          class="desktop-font-size mobile-elem toggle-title basis-85 md-basis-80 sm-basis-80 xs-basis-80"
                        >
                          {{ 'CARRIER-APPROVE.TECHNICAL' | translate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="hide-mobile hide-desktop material-shadow my-profile d-flex flex-column basis-48 md-basis-49 xs-basis-100"
            *ngIf="myProfile"
          >
            <div class="d-flex justify-between items-center">
              <h2 class="title-group">Contact</h2>
              <button
                mat-raised-button
                color="primary"
                type="button"
                class="close mt-0"
                ngClass="mt-0"
                ngClass.xs="mt-3"
                id="general-info-edit-btn"
                *ngIf="editAvailable && isTablet"
                title="{{ 'SHARED.SAVE' | translate }}"
                (click)="saveGeneralInformation(carrierForm)"
              >
                {{ 'SHARED.SAVE' | translate }}
              </button>
            </div>
            <div class="control-group contact-info" style="padding: 10px">
              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.CONTACT-NAME' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="12"
                      maxlength="100"
                      minLength="1"
                      id="contact"
                      name="contact"
                      [(ngModel)]="model.contactPerson"
                      #ContactPerson="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.PHONE-NUMBER' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="13"
                      maxlength="50"
                      minLength="1"
                      id="phone"
                      name="phone"
                      [(ngModel)]="model.phoneNumber"
                      #PhoneNumber="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.MOBILE-PHONE-NUMBER' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="14"
                      maxlength="50"
                      minLength="1"
                      id="mobile"
                      name="mobile"
                      [(ngModel)]="model.mobilePhoneNumber"
                      #MobilePhoneNumber="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.FAX-NUMBER' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="15"
                      maxlength="50"
                      minLength="1"
                      id="fax"
                      name="fax"
                      [(ngModel)]="model.faxNumber"
                      #FaxNumber="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.EMAIL-ADDRESS' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="16"
                      maxlength="100"
                      minLength="1"
                      name="email"
                      id="email"
                      (input)="clearEmailError()"
                      (focusout)="validateEmail(Email.control)"
                      [(ngModel)]="model.email"
                      #Email="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      [pattern]="emailRegex"
                      type="email"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="control display-control">
                <h3
                  class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                >
                  {{ 'CARRIER-APPROVE.WEB-SITE' | translate }}
                </h3>
                <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                  <div class="col-12 col-xl-4">
                    <input
                      tabindex="17"
                      id="website"
                      pattern="^(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,4}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&amp;?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?$"
                      maxlength="50"
                      minLength="1"
                      name="website"
                      [(ngModel)]="model.website"
                      #Website="ngModel"
                      class="input input-cp-control"
                      [ngClass]="
                        !myProfile ? 'not-profile-input-cp-control' : ''
                      "
                      type="url"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h2 class="title-group">
              {{ 'CARRIER-APPROVE.EQUIPMENT' | translate }}
            </h2>
            <div class="control-group" style="padding: 10px">
              <div
                class="control display-control d-flex flex-row md-flex-column sm-flex-column xs-flex-column"
              >
                <h3 class="desktop-font-size mobile-elem label-text">
                  {{ 'CARRIER-APPROVE.EQUIPMENT-TYPE' | translate }}
                </h3>
                <div class="basis-60 md-basis-100">
                  <div class="d-flex flex-row">
                    <div class="basis-50">
                      <div class="basis-15 md-basis-20 sm-basis-20 xs-basis-20">
                        <mat-slide-toggle
                          [color]="color"
                          class="toggle"
                          [(ngModel)]="foodChecked"
                          name="foodCheck"
                        >
                        </mat-slide-toggle>
                      </div>

                      <span
                        class="desktop-font-size mobile-elem label-text input-cp-control toggle-title ml-4 basis-85 md-basis-80 sm-basis-80 xs-basis-80"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                      >
                        {{ 'CARRIER-APPROVE.FOOD' | translate }}
                      </span>
                    </div>
                    <div class="basis-50">
                      <div class="basis-15 md-basis-20 sm-basis-20 xs-basis-20">
                        <mat-slide-toggle
                          [color]="color"
                          class="toggle"
                          [(ngModel)]="technicalChecked"
                          name="technicalCheck"
                        >
                        </mat-slide-toggle>
                      </div>

                      <span
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text input-cp-control toggle-title ml-4 basis-85 md-basis-80 sm-basis-80 xs-basis-80"
                        [ngClass]="
                          !myProfile ? 'not-profile-input-cp-control' : ''
                        "
                      >
                        {{ 'CARRIER-APPROVE.TECHNICAL' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-column gap-24 basis-40 lg-basis-40 md-basis-98 sm-basis-98 xl-basis-45 certificates-and-countries-container"
            *ngIf="myProfile"
          >
            <div
              class="d-flex flex-column basis-100 xl-basis-100 lg-basis-100 md-basis-100 sm-basis-100 xs-basis-100"
              class="material-shadow certificates-container"
            >
              <div class="basis-50 md-basis-76 sm-basis-76 lg-basis-45">
                <h2 class="title-group">Certificates</h2>
                <p
                  style="height: auto"
                  class="error-message"
                  *ngIf="displayExpiredCertificatesErrorMessage"
                >
                  <span *ngIf="isCarrierAdmin; else carrierUserErrorMessage">
                    {{
                      'CARRIER-PROFILE.CERTIFICATES-CARRIER-MESSAGE' | translate
                    }}
                  </span>
                  <ng-template #carrierUserErrorMessage>
                    <span>
                      {{
                        'CARRIER-PROFILE.CERTIFICATES-USER-MESSAGE' | translate
                      }}
                    </span>
                  </ng-template>
                </p>
                <mat-table
                  id="carrier-certificates"
                  class="table table-striped mat-table-modal-multi carrier-overview-table mat-table-modal dynamic-scroll"
                  [class.hide-mobile]="displayCertificatesCards"
                  [dataSource]="documentsDatasource"
                  matSort
                >
                  <div class="row">
                    <ng-container matColumnDef="status">
                      <mat-header-cell
                        *matHeaderCellDef
                        mat-header-cell
                        class="mat-table-header medium-size-column"
                      >
                        Status
                      </mat-header-cell>
                      <mat-cell
                        *matCellDef="let element"
                        class="medium-size-column"
                      >
                        <div [ngSwitch]="element.status">
                          <em
                            *ngSwitchCase="DocumentStatus.Missing"
                            class="fas fa-lg fa-exclamation-triangle missing-icon"
                          ></em>
                          <em
                            *ngSwitchCase="DocumentStatus.Valid"
                            class="fas fa-lg fa-check valid-icon"
                          ></em>
                          <em
                            *ngSwitchCase="DocumentStatus.Expired"
                            class="fas fa-lg fa-exclamation-triangle red-icon"
                          ></em>
                        </div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="certificateType">
                      <mat-header-cell
                        *matHeaderCellDef
                        mat-header-cell
                        class="mat-table-header certificate-type-column"
                      >
                        Type
                      </mat-header-cell>
                      <mat-cell
                        #documentTypeNameTooltip="matTooltip"
                        *matCellDef="let element"
                        class="certificate-type-column"
                        [matTooltipTouchGestures]="'on'"
                        matTooltip="{{ element.documentTypeName }}"
                        (click)="toggleTooltip(documentTypeNameTooltip)"
                      >
                        <span class="trim-text">
                          {{ element.documentTypeName }}
                        </span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="certificationName">
                      <mat-header-cell
                        *matHeaderCellDef
                        mat-header-cell
                        class="mat-table-header certificate-name-column"
                      >
                        {{ 'CARRIER-PROFILE.CERTIFICATE-NAME' | translate }}
                      </mat-header-cell>
                      <mat-cell
                        #documentNameTooltip="matTooltip"
                        *matCellDef="let element"
                        class="certificate-name-column"
                        [matTooltipTouchGestures]="'on'"
                        matTooltip="{{ element.documentName }}"
                        (click)="toggleTooltip(documentNameTooltip)"
                      >
                        <span class="trim-text">
                          {{ element.documentName }}
                        </span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="expireDate">
                      <mat-header-cell
                        *matHeaderCellDef
                        mat-header-cell
                        class="mat-table-header"
                      >
                        {{ 'CARRIER-PROFILE.EXPIRE-DATE' | translate }}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element" class="">
                        {{ CommonUtils.formatDate(element.expirationDate) }}
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                      <mat-header-cell
                        *matHeaderCellDef
                        mat-header-cell
                        class="mat-table-header column-actions-header"
                      >
                        {{ 'CARRIER-PROFILE.ACTIONS' | translate }}
                      </mat-header-cell>
                      <mat-cell
                        *matCellDef="let element; let i = index"
                        class=""
                      >
                        <div class="buttons">
                          <button
                            class="btn btn-lg btn-outline-primary doc-action-button"
                            (click)="browse(element, i)"
                            [disabled]="isImpersonated"
                            *ngIf="isCarrierAdmin"
                          >
                            <em class="fas fa-cloud-upload-alt"></em>
                          </button>
                          <button
                            class="btn btn-lg btn-outline-info doc-action-button"
                            (click)="view(element, element.documentName)"
                          >
                            <em class="fas fa-eye"></em>
                          </button>
                        </div>
                      </mat-cell>
                    </ng-container>
                  </div>
                  <mat-header-row
                    class="header-column certificates-header"
                    *matHeaderRowDef="columnsToDisplay"
                  ></mat-header-row>
                  <mat-row
                    id="{{ row.id }}"
                    *matRowDef="let row; columns: columnsToDisplay"
                  >
                  </mat-row>
                </mat-table>
                <div
                  *ngIf="displayCertificatesCards"
                  id="certificates-accordion"
                >
                  <mat-accordion multi #accordion>
                    <mat-expansion-panel
                      [expanded]="+element.id === +this.carrierCertificateId"
                      #expansionPanel
                      id="{{ element.id }}-ex"
                      class="certificate-card-text"
                      *ngFor="
                        let element of this.documentsDatasource.data;
                        let i = index
                      "
                      (opened)="openCertificatePanel(expansionPanel)"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div [ngSwitch]="element.status">
                            <em
                              *ngSwitchCase="DocumentStatus.Missing"
                              class="fas fa-lg fa-exclamation-triangle missing-icon"
                            ></em>
                            <em
                              *ngSwitchCase="DocumentStatus.Valid"
                              class="fas fa-lg fa-check valid-icon"
                            ></em>
                            <em
                              *ngSwitchCase="DocumentStatus.Expired"
                              class="fas fa-lg fa-exclamation-triangle red-icon"
                            ></em>
                          </div>
                        </mat-panel-title>
                        <mat-panel-description>
                          <span class="trim-text certificate-card-text">
                            {{ element.documentTypeName }}
                          </span>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="buttons">
                        <div class="row">
                          <div class="col-12 mobile-elem">
                            <b class="trim-text certificate-card-text">
                              {{ element.documentName }}
                            </b>
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="col-6 certificate-card-text"
                            id="expiration-date"
                          >
                            {{ CommonUtils.formatDate(element.expirationDate) }}
                          </div>
                          <div class="col-6">
                            <div class="buttons">
                              <button
                                class="btn btn-lg btn-outline-primary doc-action-button"
                                *ngIf="isCarrierAdmin"
                                (click)="browse(element, i)"
                              >
                                <em class="fas fa-cloud-upload-alt"></em>
                              </button>
                              <button
                                class="btn btn-lg btn-outline-info doc-action-button"
                                (click)="view(element, element.documentName)"
                              >
                                <em class="fas fa-eye"></em>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>
            <div
              class="material-shadow working-countries-wrapper basis-0 xl-basis-0 lg-basis-0 xs-basis-100 sm-basis-48.3 md-basis-48.3"
              *ngIf="myProfile"
            >
              <div class="d-flex justify-between items-center">
                <h2 class="title-group working-countries-title">
                  {{ 'CARRIER-PROFILE.WORKING-COUNTRIES' | translate }}
                </h2>

                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  class="close mt-0"
                  ngClass="mt-0"
                  ngClass.xs="mt-3"
                  id="country-edit-btn"
                  *ngIf="editAvailable"
                  title="{{ 'SHARED.SAVE' | translate }}"
                  (click)="saveCountries(carrierForm)"
                  [disabled]="isImpersonated"
                >
                  {{ 'SHARED.SAVE' | translate }}
                </button>
              </div>
              <div
                class="drop-list-group xl-gap-80 md-gap-64 sm-gap-64 lg-gap-48 d-flex"
                cdkDropListGroup
              >
                <div class="countries-list-container">
                  <mat-form-field floatLabel="always" id="allCountries">
                    <input
                      id="allCountries"
                      type="text"
                      class="mobile-font-size input-text"
                      placeholder="{{
                        'CARRIER-PROFILE.SELECT-COUNTRY' | translate
                      }}"
                      name="allCountries"
                      matInput
                      [formControl]="allCountriesControl"
                      [matAutocomplete]="allAuto"
                    />

                    <mat-autocomplete
                      autoActiveFirstOption
                      #allAuto="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="resetAllCountriesControl($event)"
                    >
                      <mat-option
                        *ngFor="let country of filteredAllCountries | async"
                        [value]="country"
                      >
                        {{ country.name }} ({{ country.code }})
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <h2>{{ 'CARRIER-PROFILE.ALL-COUNTRIES' | translate }}</h2>

                  <div
                    cdkDropList
                    [cdkDropListData]="allCountries"
                    class="draggable-list"
                    (cdkDropListDropped)="drop($event)"
                  >
                    <div
                      class="draggable-item"
                      *ngFor="let country of allCountries"
                      [ngStyle]="{ cursor: 'move' }"
                      cdkDrag
                    >
                      {{ country.name }} ({{ country.code }})
                    </div>
                  </div>
                </div>

                <div class="countries-list-container">
                  <mat-form-field floatLabel="always" id="removeCountry">
                    <input
                      id="removeCountry"
                      type="text"
                      class="mobile-font-size input-text"
                      placeholder="{{
                        'CARRIER-PROFILE.REMOVE-COUNTRY' | translate
                      }}"
                      name="removeCountry"
                      matInput
                      [formControl]="removeCountryControl"
                      [matAutocomplete]="removeAuto"
                    />
                    <mat-autocomplete
                      #removeAuto="matAutocomplete"
                      autoActiveFirstOption
                      [displayWith]="displayFn"
                      (optionSelected)="resetSelectedCountriesControl($event)"
                    >
                      <mat-option
                        *ngFor="
                          let country of filteredSelectedCountries | async
                        "
                        [value]="country"
                      >
                        {{ country.name }} ({{ country.code }})
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <h2>
                    {{ 'CARRIER-PROFILE.SELECTED-COUNTRIES' | translate }}
                  </h2>

                  <div
                    cdkDropList
                    [cdkDropListData]="selectedCountries"
                    class="draggable-list"
                    (cdkDropListDropped)="drop($event)"
                  >
                    <div
                      class="draggable-item"
                      *ngFor="let country of selectedCountries"
                      [ngStyle]="{ cursor: 'move' }"
                      cdkDrag
                    >
                      {{ country.name }} ({{ country.code }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #generalInfo>
  <div class="d-flex justify-between items-center">
    <h2 class="title-group">
      {{ 'CARRIER-APPROVE.GENERAL-DETAILS' | translate }}
    </h2>
    <button
      mat-raised-button
      color="primary"
      type="button"
      class="close mt-0"
      ngClass="mt-0"
      ngClass.xs="mt-3"
      id="general-info-edit-btn"
      *ngIf="editAvailable && !isTablet && (myProfile || isMobile)"
      title="{{ 'SHARED.SAVE' | translate }}"
      (click)="saveGeneralInformation(carrierForm)"
      [disabled]="isImpersonated"
    >
      {{ 'SHARED.SAVE' | translate }}
    </button>
  </div>

  <span
    class="error-message invalid-fields"
    *ngIf="!carrierForm.valid; else empty"
  >
    {{ 'ORDER-LIST-DETAILS.ERROR-FIELDS-INVALID' | translate }}
  </span>
  <ng-template #empty><span class="empty-space"> </span> </ng-template>

  <div class="control-group" style="padding: 10px">
    <div class="control display-control">
      <h3
        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
      >
        {{ 'CARRIER-APPROVE.COMPANY-NAME' | translate }}
      </h3>
      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
        <div class="col-12 col-xl-4">
          <input
            tabindex="1"
            maxlength="100"
            minLength="1"
            name="company"
            id="company"
            [(ngModel)]="model.company"
            #Company="ngModel"
            class="input input-cp-control"
            [ngClass]="!myProfile ? 'not-profile-input-cp-control' : ''"
            type="text"
            required
          />
        </div>
      </div>
    </div>

    <div class="control display-control">
      <h3
        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
      >
        {{ 'CARRIER-APPROVE.VAT-NUMBER' | translate }}
      </h3>
      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
        <div class="col-12 col-xl-4">
          <input
            tabindex="3"
            maxlength="50"
            minLength="1"
            id="vat"
            name="vat"
            appAlphaNumericDirective
            appToUpperCase
            [(ngModel)]="model.vatNumber"
            #VatNumber="ngModel"
            class="input input-cp-control"
            [ngClass]="!myProfile ? 'not-profile-input-cp-control' : ''"
            pattern="[A-Z0-9\s]+"
            type="text"
            (input)="validateVatNumber()"
            (paste)="onVatPaste($event)"
            required
          />
          <div
            class="error-message vat-error-message input-cp-control"
            *ngIf="vatHasInvalidCharacters"
          >
            {{ 'REGISTRATION.VAT-INVALID-CHARACTERS-ERROR' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="control display-control">
      <h3
        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
      >
        {{ 'CARRIER-APPROVE.CHAMBER-OF-COMMERCE' | translate }}
      </h3>
      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
        <div class="col-12 col-xl-4">
          <input
            tabindex="4"
            maxlength="50"
            minLength="1"
            id="coc"
            name="coc"
            [(ngModel)]="model.chamberOfCommerce"
            #ChamberOfCommerce="ngModel"
            class="input input-cp-control"
            [ngClass]="!myProfile ? 'not-profile-input-cp-control' : ''"
            type="text"
            required
          />
        </div>
      </div>
    </div>

    <hr *ngIf="!myProfile" />

    <div class="control display-control" *ngIf="!myProfile">
      <h3
        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
      >
        {{ 'CARRIER-APPROVE.CARRIER-CODE' | translate }}
      </h3>
      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
        <div class="col-12 col-xl-4">
          <p
            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text input-cp-control"
            [ngClass]="!myProfile ? 'not-profile-input-cp-control' : ''"
          >
            <b>{{ model.fmsCarrierCode }}</b>
          </p>
        </div>
      </div>
    </div>

    <div class="control display-control" *ngIf="!myProfile">
      <h3
        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
      >
        {{ 'CARRIER-APPROVE.PERMISSIONS' | translate }}
      </h3>
      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
        <div class="col user-claim-selection-control">
          <div
            *ngFor="let module of availableModules"
            class="col carrier-module-btn gap-16"
          >
            <div class="column d-flex justify-between">
              <div
                class="icon-container basis-15 xl-basis-0 sm-basis-15 xs-basis-15"
              >
                <img
                  src="{{ module.iconPath }}"
                  class="side-menu-icon icon-permission"
                  alt="{{ module.name }}"
                />
              </div>

              <h3
                class="title text basis-85 md-basis-84 lg-basis-65 sm-basis-70 xs-basis-70"
              >
                {{ module.translateKey | translate }}
              </h3>

              <mat-slide-toggle
                [color]="color"
                [checked]="module.available"
                class="toggle permission-toggle basis-5 lg-basis-18 md-basis-1"
                (change)="selectModule(module)"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-file-input
  name="addCarrierDocument"
  [validExtensions]="validExtensions"
  [maxSizeMb]="maxAllowedFileSize"
  (getFile)="upload($event)"
></app-file-input>
